<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <v-row v-if="componenteEvento.agregar_submodulo">
      <v-col class="d-flex justify-end" cols="12">
        <ButtonComp @click="showBatchItems" text-button="Generar Boletas en Lotes" class-color="success"
          iconBut="fas fa-file" normal-button />
      </v-col>
      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Año" v-model="filtro.id_anio" :items="lista_filtro_anios" item-value="id"
          item-text="nom_anolectivo" @change="changeFiltroAnio()" />
      </v-col>

      <v-col cols="12" sm="2" md="2">
        <AutocompleteComp text-label="Mes" v-model="filtro.num_mes" :items="lista_filtro_meses" item-value="id_mes"
          item-text="nombre_mes" @change="changeFiltroMes()" />
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Nivel" v-model="filtro.id_nivel" :items="lista_filtro_niveles" item-value="id"
          item-text="desc_nivel" @change="changeFiltroNivel()" />
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Grado" v-model="filtro.id_grado" :items="lista_filtro_grados" item-value="id"
          item-text="desc_grado" @change="changeFiltroGrado()" />
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Sección" v-model="filtro.id_seccion" :items="lista_filtro_secciones" item-value="id"
          item-text="nombre_seccion" @change="changeFiltroSeccion()" />
      </v-col>

      <v-col cols="12" md="2" sm="2">
        <AutocompleteComp text-label="Estudiante" v-model="filtro.id_estudiante" :items="lista_filtro_estudiantes"
          item-value="id" item-text="nombre_estudiante" @change="changeFiltroSeccion()" />
      </v-col>
      <v-col cols="12">
        <ComundataTablecomp :headers="BoletaLotesHeaders" :items="listItems" :search="search"
          itemkey="id_asig_movimiento_pago" v-model="selectedItems" :loading="loading" whitSearch>
          <template v-slot:fecha_vencimiento="{ item }">{{ item.fecha_vencimiento | filtroFecha }}</template>
        </ComundataTablecomp>
      </v-col>
    </v-row>

    <!-- consultar -->


    <confirm @aceptar="boletaBatch" @cancelar="cancelConfirm" :title="confirm.title" :active="confirm.active" />
  </div>
</template>

<script>
import axios from "../../../../helpers/axios";
import CommonRules from "../../commonRules";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { BoletaLotesHeaders } from '../../../../helpers/headersTable';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../../../components/ComponentsEst/AutocompleteComp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';

export default {
  components: {
    ComundataTablecomp,
    AutocompleteComp,
    ButtonComp
  },
  data: () => ({
    paramComponente: { id_submodulo: 2, id_modulo: 4 },
    dataSession: sessionStorage,
    BoletaLotesHeaders,
    selectedItems: [],
    showDialog: false,
    btnIsSaving: false,
    loading: false,
    filtro: {
      id_anio: null,
      num_mes: null,
      id_nivel: null,
      id_grado: null,
      id_seccion: null,
      id_estudiante: null
    },
    search: "",
    confirm: {
      id: 0,
      title: "",
      active: false,
    },

    rul: CommonRules(),
    listItems: [],
    lista_filtro_anios: [],
    lista_filtro_meses: [],
    lista_filtro_niveles: [],
    lista_filtro_grados: [],
    lista_filtro_secciones: [],
    lista_filtro_estudiantes: [],
    isNew: true,
    editedItem: {},
  }),

  computed: {
    formTitle() {
      return this.isNew ? "Registro de Deuda" : "Editar Registro de Deuda";
    },

    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.getListaAniosFiltro();
    this.getListaMesesFiltro();
    this.getListaAsigBoletaLotes();
  },

  created() {
    this.actualizarParamentro();
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    async showBatchItems() {
      if (this.selectedItems.length > 0) {
        this.confirm.id = 0;
        this.confirm.title = "¿Está seguro de generar boletas a los registros seleccionados?";
        this.confirm.active = true;
      }
    },

    cancelConfirm() {
      this.confirm.id = 0;
      this.confirm.title = "";
      this.confirm.active = false;
    },

    async changeFiltroAnio() {
      await this.getListaNivelesFiltro();
      await this.getListaAsigBoletaLotes();
    },

    async changeFiltroMes() {
      await this.getListaAsigBoletaLotes();
    },

    async changeFiltroNivel() {
      await this.getListaGradosFiltro();
      await this.getListaAsigBoletaLotes();
    },

    async changeFiltroGrado() {
      await this.getListaSeccionesFiltro();
      await this.getListaAsigBoletaLotes();
    },

    async changeFiltroSeccion() {
      await this.getListaEstudiantesFiltro();
      await this.getListaAsigBoletaLotes();
    },

    /// FILTROS
    getListaAniosFiltro() {
      axios
        .get("/administrativo/anoLectivo/estado/" + this.dataSession.id_colegio)
        .then((response) => {
          this.lista_filtro_anios = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaMesesFiltro() {
      axios
        .get("/tesoreria/common/mes")
        .then((response) => {
          this.lista_filtro_meses = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaNivelesFiltro() {
      this.lista_filtro_niveles = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.filtro.id_anio,
      };

      axios
        .post("/tesoreria/common/nivel", params)
        .then((response) => {
          this.lista_filtro_niveles = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaGradosFiltro() {
      this.lista_filtro_grados = [];
      let params = {
        id_colegio: this.dataSession.id_colegio,
        id_nivel: this.filtro.id_nivel
      };

      axios
        .post("/sistema/integral/getGradoAdm/", { filter: params })
        .then((response) => {
          this.lista_filtro_grados = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaSeccionesFiltro() {
      this.lista_filtro_secciones = [];
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.filtro.id_anio,
        id_nivel: this.filtro.id_nivel,
        id_grado: this.filtro.id_grado
      };
      axios
        .post("/tesoreria/common/seccion", params)
        .then((response) => {
          this.lista_filtro_secciones = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    getListaEstudiantesFiltro() {
      const params = {
        id_colegio: this.dataSession.id_colegio,
        id_anio: this.filtro.id_anio,
        id_seccion: this.filtro.id_seccion
      };
      axios
        .post("/tesoreria/common/estudiante", params)
        .then((response) => {
          this.lista_filtro_estudiantes = response.data;
        })
        .catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
        });
    },

    async getListaAsigBoletaLotes() {
      this.selectedItems = [];
      this.loading = true;
      this.filtro.id_colegio = this.dataSession.id_colegio;
      await axios
        .post("/tesoreria/asignacion/boleta_lote/consulta", this.filtro)
        .then((response) => {
          this.listItems = response.data;
          this.loading = false;
        }).catch((e) => {
          this.setEnviarMens({ tipo: "E", mensaje: `${e.error}`, tiempo: null });
          this.loading = false;
        });
    },

    async boletaBatch() {
      try {
        const params = this.selectedItems.map(x => ({
          id_asig_movimiento_pago: x.id_asig_movimiento_pago,
          numdoc_persona: x.numdoc_persona,
          nombre_estudiante: x.nombre_estudiante,
          user_id: this.dataSession.id
        }));

        let response = await axios.post("/tesoreria/asignacion/boleta_lote/boleta_batch", params);
        if (response.data.error == 1) {
          this.setEnviarMens({ tipo: "E", mensaje: `${response.data.message}`, tiempo: null });
        }
        else {
          this.setEnviarMens({ tipo: "S", mensaje: `${response.data.message}`, tiempo: null });
          this.showDialog = false;
          this.cancelConfirm();
          this.getListaAsigBoletaLotes();
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },
  },
};
</script>